const deviceSizes = {
  large: "1200px",
  mobile: "1000px",
  modal: "700px",
  small: "400px",
};

const theme = {
  large: `screen and (max-width: ${deviceSizes.large})`,
  mobile: `screen and (max-width: ${deviceSizes.mobile})`,
  modal: `screen and (max-width: ${deviceSizes.modal})`,
  small: `screen and (max-width: ${deviceSizes.small})`,
};

export default theme;
